import React, { useState } from 'react';
import { string } from 'prop-types';

import { SeeMoreLessLink, NoteSectionElement } from './note-section.style';

/**
 * Note Section Component
 * @param {object} params - Object containing props
 * @param {string} param.note - Note to display
 * @return {element}
 */
const NoteSection = ({ note }) => {
  const [textExpanded, setTextExpanded] = useState(false);
  if (!note) {
    return null;
  }

  /**
   * Helper function to truncate note if needed
   * @return {string}
   */
  const truncateNote = () => {
    if (textExpanded || !note || (note.length <= 140)) {
      return note;
    }
    return `${note.substring(0, 140)}...`;
  };

  /**
   * Renders the see more link
   * @param {number} length - Length of current note
   * @returns {element}
   */
  const renderSeeMoreLink = (length) => {
    if (length > 140) {
      return (
        <SeeMoreLessLink
          onClick={() => setTextExpanded(!textExpanded)}
          truncate={textExpanded}
        >
          See more
        </SeeMoreLessLink>
      );
    }
    return null;
  };

  /**
   * Renders the see less link
   * @param {number} length - Length of current note
   * @returns {element}
   */
  const renderSeeLessLink = (length) => {
    if (length > 150) {
      return (
        <SeeMoreLessLink
          onClick={() => setTextExpanded(!textExpanded)}
          truncate={textExpanded}
        >
          See less
        </SeeMoreLessLink>
      );
    }
    return null;
  };

  // Run note through truncatedNoteFunction
  const truncatedNote = truncateNote(note);
  return (
    <div data-testid="note-section">
      <NoteSectionElement truncate={textExpanded}>
        {truncatedNote}
        {textExpanded && renderSeeLessLink(truncatedNote?.length)}
        {!textExpanded && renderSeeMoreLink(truncatedNote?.length)}
      </NoteSectionElement>
    </div>
  );
};

NoteSection.propTypes = {
  note: string,
};

NoteSection.defaultProps = {
  note: null,
};

export default NoteSection;
